import Component from '../colorz/Component';
import Device from '@utils/html/Device';
import {breakpointsApp} from '../colorz/configClrzApp';

export default class TabIndexMobile extends Component {
	onInit(el) {
		this.el = el;
	}

	onReady() {
		this.isMobile = Device.width < breakpointsApp.desktop;

		if (this.isMobile) {
			this.el.removeAttribute('hidden');
			this.el.removeAttribute('tabindex');

			if (this.el.hasAttribute('aria-hidden')) {
				this.el.removeAttribute('aria-hidden');
			}

			if (this.el.hasAttribute('inert')) {
				this.el.removeAttribute('inert');
			}
		}
	}
}
